var _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDot2 = function SvgDot2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "#424242"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.19,
    cy: 15.69,
    r: 3.69
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.766,
    cy: 15.69,
    r: 3.69
  })));
};
export { SvgDot2 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0iIzQyNDI0MiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOS4xOSIgY3k9IjE1LjY5IiByPSIzLjY5Ii8+CjxjaXJjbGUgY3g9IjIyLjc2NjIiIGN5PSIxNS42OSIgcj0iMy42OSIvPgo8L3N2Zz4K";